import React, { Fragment, useState, useEffect } from "react";
import NotificationsTable from "./NotificationsTable";
import { getAllNotifications } from "../../../actions/Utilities/Notification";
import { useRecoilValue } from "recoil";
import { accountAtom } from "../../Login/atoms/AccountAtom";
import Welcome from "../../Dashboard/WelcomePage";
import CustomLoader from "../../../components/CustomLoader";
import { BellIcon } from "@heroicons/react/24/solid";
const NotificationList = () => {
  const [notificationsData, setNotificationsDate] = useState([]);
  const [notifLoading, setNotifLoading] = useState(true);
  const userAccount = useRecoilValue(accountAtom);

  useEffect(() => {
    let query = [];
    getAllNotifications(
      userAccount?.emailAddress,
      userAccount?.isFranchise,
      query
    ).then((data) => {
      setNotifLoading(false);
      setNotificationsDate(data);
    });
  }, [userAccount?.isFranchise, userAccount?.emailAddress]);
  return (
    <Fragment>
      {!userAccount.userName ? (
        <CustomLoader />
      ) : !userAccount?.rolePermissions.length > 0 ? (
        <Welcome />
      ) : (
        <div className="bg-tabColor pt-2">
          <div className="bg-white animate-fade-in-down px-8 py-4">
            <div className="flex gap-2 items-center mb-6">
              <div className="">
                <BellIcon className="text-white bg-blue-500 rounded-md h-7 w-7 p-1" />
              </div>
              <div className="space-y-5 pb-4">
                <h1 className="titleDiv text-primary">Notifications</h1>
              </div>
            </div>
            <div className="flex w-full ">
              <div className="bg-white w-full"></div>
            </div>
            <NotificationsTable
              notificationsData={notificationsData}
              notifLoading={notifLoading}
            />
          </div>
        </div>
      )}
    </Fragment>
  );
};

export default NotificationList;
